import React, { useState, useEffect } from 'react';
import { api } from '../services/api';

const SEVERITY_COLORS: Record<string, string> = {
  info: 'var(--blue)',
  warning: 'var(--accent)',
  critical: 'var(--red)',
};

export function AuditPage() {
  const [entries, setEntries] = useState<any[]>([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(true);
  const [severity, setSeverity] = useState('');
  const [action, setAction] = useState('');
  const [page, setPage] = useState(0);
  const limit = 50;

  useEffect(() => {
    setLoading(true);
    const params = new URLSearchParams({ limit: String(limit), offset: String(page * limit) });
    if (severity) params.set('severity', severity);
    if (action) params.set('action', action);
    api.get(`/audit?${params}`).then(r => {
      setEntries(r.data.entries || []);
      setTotal(r.data.total || 0);
    }).finally(() => setLoading(false));
  }, [severity, action, page]);

  const ACTIONS = ['login', 'logout', 'clock_in', 'clock_out', 'screenshot_taken', 'user_created', 'user_updated', 'settings_changed'];

  return (
    <div style={{ padding: '28px 32px' }}>
      <div className="page-header">
        <div>
          <h1 className="page-title">Auditoría</h1>
          <p className="page-subtitle">{total} registros totales</p>
        </div>
        <div style={{ display: 'flex', gap: 8 }}>
          <select className="input" style={{ width: 140 }} value={severity} onChange={e => { setSeverity(e.target.value); setPage(0); }}>
            <option value="">Todas las severidades</option>
            <option value="info">Info</option>
            <option value="warning">Advertencia</option>
            <option value="critical">Crítico</option>
          </select>
          <select className="input" style={{ width: 160 }} value={action} onChange={e => { setAction(e.target.value); setPage(0); }}>
            <option value="">Todas las acciones</option>
            {ACTIONS.map(a => <option key={a} value={a}>{a}</option>)}
          </select>
        </div>
      </div>

      <div className="card" style={{ padding: 0, overflow: 'hidden' }}>
        <table className="table">
          <thead>
            <tr>
              <th>Fecha/Hora</th>
              <th>Usuario</th>
              <th>Acción</th>
              <th>Recurso</th>
              <th>Descripción</th>
              <th>Severidad</th>
              <th>IP</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr><td colSpan={7} style={{ textAlign: 'center', padding: 40, color: 'var(--text3)' }}>Cargando...</td></tr>
            ) : entries.length === 0 ? (
              <tr><td colSpan={7} style={{ textAlign: 'center', padding: 40, color: 'var(--text3)' }}>Sin registros</td></tr>
            ) : entries.map(e => (
              <tr key={e.id}>
                <td style={{ fontSize: 11, color: 'var(--text3)', whiteSpace: 'nowrap' }}>
                  {new Date(e.createdAt).toLocaleString('es-ES', { day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit' })}
                </td>
                <td style={{ fontSize: 12 }}>{e.userName || `#${e.userId}` || '—'}</td>
                <td><code style={{ fontSize: 11, background: 'var(--bg3)', padding: '2px 6px', borderRadius: 4 }}>{e.action}</code></td>
                <td style={{ fontSize: 11, color: 'var(--text3)' }}>{e.resource}{e.resourceId ? ` #${e.resourceId}` : ''}</td>
                <td style={{ fontSize: 11, maxWidth: 200, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{e.description || '—'}</td>
                <td>
                  <span style={{ fontSize: 10, fontWeight: 600, color: SEVERITY_COLORS[e.severity] || 'var(--text3)', textTransform: 'uppercase' }}>
                    {e.severity}
                  </span>
                </td>
                <td style={{ fontSize: 11, color: 'var(--text3)' }}>{e.ipAddress || '—'}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {total > limit && (
        <div style={{ display: 'flex', justifyContent: 'center', gap: 8, marginTop: 16 }}>
          <button className="btn btn-secondary" disabled={page === 0} onClick={() => setPage(p => p - 1)}>← Anterior</button>
          <span style={{ padding: '8px 12px', fontSize: 12, color: 'var(--text3)' }}>Página {page + 1} de {Math.ceil(total / limit)}</span>
          <button className="btn btn-secondary" disabled={(page + 1) * limit >= total} onClick={() => setPage(p => p + 1)}>Siguiente →</button>
        </div>
      )}
    </div>
  );
}
